// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0c5e047d","160":"7a4efdcd","208":"7f376cf7","293":"1ccd7460","453":"a46f9121","516":"b31754e5","519":"fe0a247a","917":"1f622266","946":"1c769cfa"}[chunkId] + ".chunk.js";
};